import {KTSVG} from '../../../_metronic/helpers'
import React, {FC, forwardRef, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useWindowWidth} from '@react-hook/window-size/throttled'
import useNotificationSound from '../../helpers/notifications/useNotificationSound'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/en';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)

type Props = {
  show: boolean
  handleClose: () => void
  mpesacallbackstatus: any
}

interface PaymentData {
  Amount: number
  MpesaReceiptNumber: string
  TransactionDate: number
  PhoneNumber: string
}


const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }
  
  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num
  
  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }
  
  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME

export const MpesastkCallbackStatus: FC<Props> = forwardRef((props, ref) => {
  const truncate = require('truncate')
  const onlyWidth = useWindowWidth()
  const {playSound} = useNotificationSound({audioFileUrl: '/media/sound/notification.mp3'})

  const extractValueByKey = (key: string): any => {

    if(props.mpesacallbackstatus.ResultParameters && Array.isArray(props.mpesacallbackstatus.ResultParameters) &&
      props.mpesacallbackstatus.ResultParameters.length > 0 ){
    const transaction = props.mpesacallbackstatus.ResultParameters.find(
      (transaction: any) => transaction.Key === key
    )
    return transaction ? transaction.Value : null
      }
      else{
        return null
      }
  }

  const debitPartyName = extractValueByKey('DebitPartyName')
  const creditPartyName = extractValueByKey('CreditPartyName')
  const initiatedTime = extractValueByKey('InitiatedTime')
  const debitAccountType = extractValueByKey('DebitAccountType')
  const transactionReason = extractValueByKey('TransactionReason')
  const reasontype = extractValueByKey('ReasonType')
  const transactionStatus = extractValueByKey('TransactionStatus')
  const finalisedTime = extractValueByKey('FinalisedTime')
  const amount = extractValueByKey('Amount')
  const receiptNo = extractValueByKey('ReceiptNo')
  const creditPartyCharges = extractValueByKey('CreditPartyCharges')
  const creditPartyChargesValue = creditPartyCharges
    ? parseFloat(creditPartyCharges.split('|')[2])
    : null

  useEffect(() => {
    if (props.show) {
      playSound()
    }
    const timeoutId = setTimeout(() => {
      props.handleClose()
    }, 300000)

    return () => {
      clearTimeout(timeoutId)
    }
  }, [props.show])

  return (
    <Modal
      className='modal fade'
      id='kt_modal_dashboard'
      data-backdrop='static'
      tabIndex={-1}
      role='dialog'
      show={props.show}
      centered
      dialogClassName='modal-lg'
      aria-hidden='true'
      onHide={props.handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h3 className='fw-bolder'>
            Status Callback
            <span className='h-10px border-gray-200 border-start mx-2'></span>
            <span className='text-muted fw-bold fs-6'>{receiptNo ? receiptNo : "Not Available"}</span>
          </h3>

          <div
            className='btn btn-icon btn-sm btn-active-light-primary ms-2'
            onClick={props.handleClose}
          >
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <div className='fv-row mb-7'>
            
            <div className='card bg-light'>
              {/* begin::Header */}
              <div className='card-header border-0 pt-5'>
                <h3 className='card-title align-items-start flex-column'>
                  <span className='required card-label fw-bolder fs-5 mb-1'>Status Summary</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>
                    Conversation id: {props.mpesacallbackstatus.ConversationID}
                  </span>
                  <div className='mt-2'>
                  <span className='text-muted mt-1 fw-bold fs-7'>
                  Transaction Status: <span className='fw-bolder'>{transactionStatus ? transactionStatus : "Not Available"}</span>
                  </span>
                  </div>
                </h3>
              </div>
              {/* end::Header */}
              {/* begin::Body */}
              <div className='card-body py-3'>
                <>
                  

                  {props.mpesacallbackstatus.ResultParameters && Array.isArray(props.mpesacallbackstatus.ResultParameters) &&
                  props.mpesacallbackstatus.ResultParameters.length > 0 ? (
                    <>
                    <span>{props.mpesacallbackstatus.ResultDesc}</span>
                    <div className='mt-2'>
                      <span className='mt-2'>
                        You received a payment of{' '}
                        <span className='fw-bolder'>
                          {addCommas(amount.toFixed(2))} {CURRENCY_APP}{' '}
                        </span>{' '}
                        from <span className='fw-bolder'>{debitPartyName}</span>. This amount was
                        paid to <span className='fw-bolder'>{creditPartyName}</span> on{' '}
                        <span className='fw-bolder'>
                          {dayjs(String(finalisedTime), 'YYYYMMDDHHmmss').locale('en').format('LLLL')}
                        </span>
                        . You were charged{' '}
                        <span className='fw-bolder'>
                          {addCommas(Number(creditPartyChargesValue).toFixed(2))} {CURRENCY_APP}{' '}
                        </span>{' '}
                        for the transaction.
                      </span>
                      </div>
                      <div className='mt-2'>
                      <span className='mt-2'>
                        Reason for transaction: <span className='fw-bolder'>{reasontype}</span>
                      </span>
                      </div>
                      
                    </>
                  ) : (
                    <>
                    <span className='text-danger'>{props.mpesacallbackstatus.ResultDesc}</span>
                    </>
                  )}
                  <span className='mb-2'></span>
                </>
              </div>
              {/* begin::Body */}
            </div>
          </div>
        </div>
        <div className='modal-footer border-0 mt-n5'>
          <button type='button' className='btn btn-light-primary' onClick={props.handleClose}>
            Close
          </button>
        </div>
      </div>
    </Modal>
  )
})
